import styled from '@emotion/styled';
import Slider from 'react-slick';

const StyledSlider = styled(Slider)`
  .slick-slide {
    height: auto;
  }

  .slick-dots {
    display: flex !important;
    flex-direction: column;
    list-style: none;
    text-align: center;
    top: 40%;
    transform: translateY(-30%);
    right: -99%;
  }

  .slick-dots li {
    height: 30px;
  }

  .slick-dots li button:before {
    color: #d5d5d5 !important;
    font-size: 10px;
    opacity: 1;
  }

  .slick-dots li.slick-active button:before {
    color: #2277d1 !important;
  }
`;

export default StyledSlider;
